const ProfileImage = () => (
  <div className="flex justify-center mt-8">
    <div className="relative w-[40vw] max-w-[12rem] sm:max-w-[15rem] md:max-w-[20rem] lg:max-w-[24rem] aspect-square rounded-full bg-gray-200 flex items-center justify-center overflow-hidden border-4 sm:border-6 md:border-8 border-gray-300 shadow-2xl">
      <img
        src="/profile.jpg"
        alt="Profile"
        className="w-full h-full object-cover rounded-full"
      />
      <div className="absolute inset-0 border-[6px] sm:border-[8px] md:border-[12px] border-blue-900 rounded-full"></div>
    </div>
  </div>
);

export default ProfileImage;
